import { h as _extends } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import './_commonjsHelpers-97e6d7b1.js';
import 'moment';

function Input(props) {
  var name = props.name,
    type = props.type,
    label = props.label,
    className = props.className,
    onChange = props.onChange,
    required = props.required,
    showError = props.showError,
    value = props.value,
    onKeyUp = props.onKeyUp,
    onKeyDown = props.onKeyDown,
    onKeyPress = props.onKeyPress,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    extraContent = props.extraContent,
    errorMessage = props.errorMessage,
    icon = props.icon,
    reference = props.reference,
    readOnly = props.readOnly,
    disabled = props.disabled,
    onClick = props.onClick,
    labelHint = props.labelHint,
    qaData = props.qaData,
    placeholder = props.placeholder;
  var iconPosition = props.iconPosition;
  iconPosition = ['left', 'right'].some(function (validPosition) {
    return validPosition === iconPosition;
  }) ? "bf-input-icon-position-".concat(iconPosition) : '';
  var inputLabel = /*#__PURE__*/React__default.createElement("label", {
    htmlFor: name,
    className: "bf-form-element-label"
  }, label);
  var inputWrapperClasses = "bf-form-element-wrapper \n        ".concat(required ? 'bf-form-element-is-required' : '', " \n        ").concat(showError ? 'bf-form-element-has-error' : '', "\n        ").concat(className, " \n    ");
  return /*#__PURE__*/React__default.createElement("div", {
    className: inputWrapperClasses
  }, label ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-wrapper"
  }, labelHint ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, inputLabel, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-hint"
  }, labelHint)) : inputLabel) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-input-wrapper ".concat(iconPosition)
  }, icon ? /*#__PURE__*/React__default.createElement(Icon, {
    name: icon
  }) : null, /*#__PURE__*/React__default.createElement("input", _extends({
    type: type,
    name: name,
    ref: reference,
    onChange: onChange,
    className: "bf-form-element ".concat(showError ? 'bf-form-element-has-error' : ''),
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    required: required,
    readOnly: readOnly,
    disabled: disabled,
    placeholder: placeholder,
    value: value
  }, qaData))), showError && errorMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-error-message"
  }, errorMessage) : null, extraContent ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-extra-content"
  }, extraContent) : null);
}
Input.defaultProps = {
  className: '',
  label: '',
  labelHint: '',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {},
  required: false,
  type: 'text',
  extraContent: '',
  icon: '',
  iconPosition: '',
  readOnly: false,
  disabled: false,
  reference: null,
  onClick: function onClick() {},
  qaData: {},
  showError: false,
  errorMessage: '',
  placeholder: '',
  value: undefined
};
Input.propTypes = {
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Input label
   */
  label: nodeOrStringProp,
  /**
  Input hint
   */
  labelHint: nodeOrStringProp,
  /**
  Input name
   */
  name: PropTypes.string,
  /**
  Function onBlur
   */
  onBlur: PropTypes.func,
  /**
  Function onChange
   */
  onChange: PropTypes.func,
  /**
  Function onFocus
   */
  onFocus: PropTypes.func,
  /**
  Function onKeyDown
   */
  onKeyDown: PropTypes.func,
  /**
  Function onKeyPress
   */
  onKeyPress: PropTypes.func,
  /**
  Function onClick
   */
  onClick: PropTypes.func,
  /**
  Function onKeyUp
   */
  onKeyUp: PropTypes.func,
  /**
  Required Input
   */
  required: PropTypes.bool,
  /**
  Input type
   */
  type: PropTypes.string,
  /**
  Element render after Input
   */
  extraContent: nodeOrStringProp,
  /**
  Icon to show inside Input
   */
  icon: PropTypes.string,
  /**
  Icon position (left or right)
   */
  iconPosition: PropTypes.string,
  /**
  readOnly Input
   */
  readOnly: PropTypes.bool,
  /**
  Input disabled
   */
  disabled: PropTypes.bool,
  /**
  Input ref
   */
  reference: PropTypes.shape({}),
  qaData: PropTypes.shape({}),
  /**
  Show Input with error status
   */
  showError: PropTypes.bool,
  /**
  Error message on error status
   */
  errorMessage: nodeOrStringProp,
  /**
  Input placeholder
   */
  placeholder: PropTypes.string,
  /**
  Input value (can't be modified by the user)
   */
  value: PropTypes.string
};

export default Input;
